// Initialize testimonial slider
function initializeHomepageTestimonialSlider() {

    StepStone.homepageTestimonialSlider = $('.stepstone-testimonial-slider');

    StepStone.homepageTestimonialSlider.slick({
        autoplay: true,
        autoplaySpeed: 5500,
        dots: true,
        dotsClass: 'stepstone-slick-slider-dots',
        appendDots: StepStone.homepageTestimonialSlider,
        arrows: false,
        easing: 'swing',
        slidesToShow: 1,
        infinite: true,
        mobileFirst: true,
        draggable: false,
        swipe: true,
        adaptiveHeight: true
    });

} // initializeHomepageTestimonialSlider()

function initializeCarouselFade() {
    StepStone.carousel = $('.section-homepage-hero');

    StepStone.carouselSlides = StepStone.carousel.find('img');

    var i = 0;
    setInterval(function(){
        if (i > StepStone.carouselSlides.length - 1) {
            i = 0;
        }
        $(StepStone.carouselSlides).removeClass('active');
        $(StepStone.carouselSlides[i]).addClass('active');
        console.log(StepStone.carouselSlides[i]);
        i++;
    },3000);

}

if ($('body').hasClass('page-template-page-homepage')) {
    // Testimonial Slider
    initializeHomepageTestimonialSlider();
    initializeCarouselFade();

    // Reinitialize sliders on resize or orientation change
    $(window).on('resize orientationchange', function () {
        StepStone.homepageTestimonialSlider.slick('resize');
    });
}